export default __webpack_public_path__ + "static/IBMPlexSans-Medium-Cyrillic-2ad431543fa3d519c5be99b5dfcbd77f.woff";